$(() => {
  const childrenDictionary = {};

  $('input[type="checkbox"][data-parent-checkbox]').each(function() {
    const child = $(this);
    const parentSelector = $(this).data('parent-checkbox');
    const parent = $(parentSelector);
    const children = childrenDictionary[parentSelector] || (childrenDictionary[parentSelector] = []);
    children.push(child);

    parent.on('change', function() {
      if ($(this).prop('indeterminate')) {
        return;
      }
      child.prop({ checked: $(this).prop('checked') });
    });

    const refreshParentState = () => {
      const nChecked = children.filter(c => $(c).prop('checked')).length;
      if (nChecked === 0) {
        parent.prop({ checked: false, indeterminate: false });
      } else if (nChecked === children.length) {
        parent.prop({ checked: true, indeterminate: false });
      } else {
        parent.prop({ indeterminate: true });
      }
    };

    child.on('change', refreshParentState);
    refreshParentState();
  });
});
